import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  closeButton: {
    padding: '4px',
  },
  dialogActions: {
    padding: '16px',
    gap: '8px',
  },
  menuMaxLimitMessageContainer: {
    display: 'flex',
    lineHeight: '16px',
    background: '#fffbeb',
    padding: '16px',
    margin: '20px 0 16px 0',
    border: '1px solid #f59e0b',
  },
  warningIcon: {
    fill: '#f59e0b',
    marginRight: '8px',
    fontSize: '20px',
  },
  labelContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px',
  },
  formLabel: {
    fontSize: '16px',
    fontWeight: foundations.typography.fontWeight.medium,
  },
});
